import { Component } from "react";
import "./Exports.scss";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetExportDTO from "../../../models/DTO/IGetExportDTO";
import IGetExportsDTO from "../../../models/DTO/IGetExportsDTO";
import IOnGetExportsDTO from "../../../models/DTO/IOnGetExportsDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import IExport from "../../../models/IExport";
import IOwTableCols from "../../../models/IOwTableCols";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import UserService from "../../../services/UserService";
import { FormattedMessage } from "react-intl";
import * as _ from "lodash-es";
import moment from "moment";
import systemConst from "../../../services/SystemConst";
import ExportFilter from "./ExportFilter/ExportFilter";
import { Socket } from "socket.io-client";
import { SearchSection } from "../../shared/SearchSection/SearchSection";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    setSidebarComponent: any;
};

type State = {
    limit: number;
    offset: number;
    exports: any[];
    totalExports: number;
    breadcrumbs: IBreadcrumbs[];
    queryString?: string;
    columns: IOwTableCols[];
    dataFetch: boolean;
    initialData: boolean;
};

class Exports extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        const breadcrumbs = [
            { title: "Dashboard", url: "/dashboard" },
            { title: "Exports", url: "/exports" },
        ];

        this.state = {
            limit: 5,
            offset: 0,
            exports: [],
            totalExports: 0,
            breadcrumbs,
            columns: [
                {
                    title: "link",
                    renderFnEmitsRow: true,
                    renderFn: this.renderLinkCol,
                    valueProp: "",
                },
                {
                    title: "expiration_date",
                    renderFnEmitsRow: true,
                    renderFn: this.renderExpDateCol,
                    valueProp: "",
                },
                {
                    title: "created_at",
                    renderFnEmitsRow: true,
                    renderFn: this.renderCreatedAtCol,
                    valueProp: "",
                },
            ],
            dataFetch: false,
            initialData: true,
        };
    }

    async componentDidMount() {
        this.props.socket.on(EndpointsEnum.ExportOnGetExports, this.onGetExports);
        this.props.socket.on(EndpointsEnum.ExportOnCreateExport, this.onCreateExport);
        this.props.socket.on(EndpointsEnum.ExportOnGetExport, this.onGetExport);

        this.getExports();
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.ExportOnGetExports, this.onGetExports);
        this.props.socket.removeListener(EndpointsEnum.ExportOnCreateExport, this.onCreateExport);
        this.props.socket.removeListener(EndpointsEnum.ExportOnGetExport, this.onGetExport);
    }

    getExports = (queryString?: string) => {
        const data: IGetExportsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            queryString,
            offset: this.state.offset,
            limit: this.state.limit,
        };

        this.props.socket.emit(EndpointsEnum.ExportGetExports, data);

        this.setState({
            dataFetch: true,
        });
    };

    onGetExports = (data: IOnGetExportsDTO) => {
        const { exports, totalExports } = data;

        this.setState({
            exports,
            totalExports,
            dataFetch: false,
            initialData: false,
        });
    };

    onCreateExport = () => {
        this.getExports();
    };

    getExport = (exportGuid: string) => {
        const payload: IGetExportDTO = {
            exportGuid,
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ExportGetExport, payload);
    };

    onGetExport = (data: any) => {
        // console.log("onGetExport", data);

        const filename = this.getFilenameFromS3Key(data.filename);

        this.downloadFile(data.Body, filename);
    };

    downloadFile = (dataArray: any, filename: string) => {
        const blob = new Blob([dataArray], { type: "application/zip" });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${filename}.zip`;
        link.click();
    };

    paginationChanged = (offset: number, limit: number) => {
        this.setState(
            {
                offset,
                limit,
            },
            () => {
                this.getExports();
            }
        );
    };

    filterExports = (queryString?: string) => {
        this.setState(
            {
                queryString,
            },
            () => {
                this.getExports(queryString);
            }
        );
    };

    getTableHeader = () => {
        return (
            <thead>
                <tr>
                    <th>
                        <FormattedMessage id="link" defaultMessage="_Link_" description="Link Title" />
                    </th>

                    <th>
                        <FormattedMessage id="expiration_date" defaultMessage="_Expiration Date_" description="Expiration Date Title" />
                    </th>

                    <th>
                        <FormattedMessage id="created_at" defaultMessage="_Created At_" description="Created At Title" />
                    </th>
                </tr>
            </thead>
        );
    };

    renderLinkCol = (row: any) => {
        const filename = this.getFilenameFromS3Key(row.filename);

        return (
            <a
                className={"pointer"}
                onClick={() => {
                    this.getExport(row.guid);
                }}>
                {filename}
            </a>
        );
    };

    renderExpDateCol = (row: IExport) => {
        const todayMoment = moment();
        const expirateDateMoment = moment(row.expiration_date, systemConst.defaultValue.dateFormat);
        const expireAtHumanReadable = moment(row.expiration_date).format("YYYY-MM-DD");

        const expiration_date_parsed = expirateDateMoment.diff(todayMoment, "days");

        let expirated_date_str = (
            <span className="text-warning">
                <FormattedMessage id="expired" defaultMessage="_Expired_" description="Expired Title" />
            </span>
        );

        if (expiration_date_parsed > 0) {
            expirated_date_str = (
                <div>
                    <div>
                        <span className="me-2">{expiration_date_parsed}</span>
                        <FormattedMessage id="days" defaultMessage="_Days_" description="Days Title" />
                    </div>
                    <div className={"placeholder-disabled font-small"}>{expireAtHumanReadable}</div>
                </div>
            );
        }

        return <div>{expirated_date_str}</div>;
    };

    renderCreatedAtCol = (row: IExport) => {
        const created_at_parsed = UserService.parseDate(row.created_at);

        return <td>{created_at_parsed}</td>;
    };

    getFilenameFromS3Key = (key: string) => {
        const filename_start = key.indexOf("/") + 1;

        const filename = key.substring(filename_start, key.length);

        return filename;
    };

    getTableBody = () => {
        if (!this.state.exports.length) {
            return null;
        }

        const tbodyRows = _.map(this.state.exports, (exportDetail, index) => {
            const filename = this.getFilenameFromS3Key(exportDetail.filename);

            const todayMoment = moment();
            const expirateDateMoment = moment(exportDetail.expiration_date, systemConst.defaultValue.dateFormat);
            const expireAtHumanReadable = moment(exportDetail.expiration_date).format("YYYY-MM-DD");

            const expiration_date_parsed = expirateDateMoment.diff(todayMoment, "days");
            const created_at_parsed = UserService.parseDate(exportDetail.created_at);

            let expirated_date_str = (
                <span className="text-warning">
                    <FormattedMessage id="expired" defaultMessage="_Expired_" description="Expired Title" />
                </span>
            );

            if (expiration_date_parsed > 0) {
                expirated_date_str = (
                    <div>
                        <div>
                            <span className="me-2">{expiration_date_parsed}</span>
                            <FormattedMessage id="days" defaultMessage="_Days_" description="Days Title" />
                        </div>
                        <div className={"placeholder-disabled font-small"}>{expireAtHumanReadable}</div>
                    </div>
                );
            }

            return (
                <tr key={index}>
                    <td>
                        <a
                            className={"pointer"}
                            onClick={() => {
                                this.getExport(exportDetail.guid);
                            }}>
                            {filename}
                        </a>
                    </td>
                    <td>{expirated_date_str}</td>
                    <td>{created_at_parsed}</td>
                </tr>
            );
        });

        return <tbody>{tbodyRows}</tbody>;
    };

    render() {
        return (
            <div className="Exports">
                <div className="row">
                    <div className={"col-12 d-flex align-items-center justify-items-center"}>
                        <OwTitle className={"mt-3 me-3"} leftIconName={"fad fa-file-export"} title={"exports"} />
                    </div>
                </div>

                <div className={"mb-2"}>
                    <SearchSection>
                        <ExportFilter searchFn={this.filterExports} />
                    </SearchSection>
                </div>

                <div className={"row"}>
                    <div className={"col-12 table-responsive"}>
                        <OwTable
                            columns={this.state.columns}
                            dataSet={this.state.exports}
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            dataFetch={this.state.dataFetch}
                            initialData={this.state.initialData}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Exports;
